import {fetchSubStations} from "../network/StageNetworkAPI";
import {readFilterState, saveFilterState} from "../../util/Util";
import {STAGE_FILTER_STATE_KEY} from "../../util/LocalStorageKeys";
import {STAGE_TAB_METRIC_KEY} from "../../util/MetricUtil";

export const StageFilterReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_FILTER_DATA": {
            const newState = {...state, data: {...state.data, ...action.data}}
            saveFilterState(STAGE_FILTER_STATE_KEY, newState);
            return newState
        }
        case "SELECT_CLUSTER": {
            const newState = {...state, cluster: action.Cluster}
            saveFilterState(STAGE_FILTER_STATE_KEY, newState);
            return newState
        }
        case "SELECT_DRIVER_TYPE": {
            const newState = {...state, driverType: action.DriverType}
            saveFilterState(STAGE_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_STATUS": {
            const newState = {...state, status: action.status}
            saveFilterState(STAGE_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_DEPARTURE": {
            const newState = {...state, departure: action.Departure}
            saveFilterState(STAGE_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_VIEW_TYPE": {
            const newState = {...state, viewType: action.viewType}
            saveFilterState(STAGE_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_STAGE_TAB_VIEW_TYPE": {
            return {...state, stageTabViewType: action.stageTabViewType};
        }
        case "UNLOAD_VIEW":
            return state
        case "REMOVE_ALL_FILTER": {
            const newState = {...state};
            Object.entries(state).forEach(entry => {
                const key = entry[0];
                const values = entry[1];
                if (Array.isArray(values) && values.length && key !== 'data') {
                    newState[key] = [];
                }
            });
            saveFilterState(STAGE_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "REMOVE_FILTER": {
            const {key, value} = action.data
            state[key] = state[key].filter(item => item !== value)
            const newItem = state[key].filter(item => item !== value)
            const newState = {...state, [key]: newItem}
            saveFilterState(STAGE_FILTER_STATE_KEY, newState);
            return newState
        }
        case "LOAD_XPT_NODES":
            const {dispatcher, baseUrl, capability, stationConfig} = action.data;
            fetchSubStations(dispatcher, baseUrl, capability, STAGE_TAB_METRIC_KEY, stationConfig);
            return state;
        case "RECEIVE_XPT_NODES": {
            const {xptNodes} = action.data;
            const savedState = readFilterState(STAGE_FILTER_STATE_KEY);
            let newState = {...state, xptNodes, data: {...state.data, xptNodes}};
            if (savedState) {
                newState = {...state, data: {...state.data, xptNodes}};
            }
            saveFilterState(STAGE_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_XPT_NODE": {
            const newState = {...state, xptNodes: action.xptNodes}
            saveFilterState(STAGE_FILTER_STATE_KEY, newState);
            return newState
        }
        case "SELECT_STAGE_LOCATION_TYPE": {
            const newState = {...state, stageLocationType: action.stageLocationType}
            saveFilterState(STAGE_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "LOAD_FILTERS": {
            const savedState = readFilterState(STAGE_FILTER_STATE_KEY);
            if (savedState) {
                return {
                    ...state,
                    ...savedState
                }
            }
            return state;
        }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/stageStatus/reducers/StageFilterReducer.js